// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NqZV","delete":"styles_delete__3cZNv","update":"styles_update__VboE1","add":"styles_add__2Mvlz"};